/** Bell badge display — matches brushfire-web-provider nav */
export function formatUnreadBadgeDisplay(count: number): string | number {
  if (count <= 0) return 0
  if (count > 9) return '9+'
  return count
}

export function notificationsBellAriaLabel(unreadCount: number): string {
  const suffix = unreadCount > 0 ? `, ${unreadCount} unread` : ''
  return `Notifications${suffix}`
}
